import { Outlet } from 'react-router';
import { AdminSidebar } from '@/components/admin-sidebar';
import { AdminHeader } from '@/components/admin-header';

export function AdminLayout() {
  return (
    <div
      className="flex h-screen overflow-hidden"
      style={{ background: 'var(--bg-canvas)', color: 'var(--fg-high)' }}
    >
      <AdminSidebar />
      <div className="flex flex-1 flex-col overflow-hidden min-w-0">
        <AdminHeader />
        <main className="flex-1 overflow-y-auto overflow-x-hidden">
          <div className="mx-auto w-full max-w-[1760px] min-w-0 px-6 py-6 xl:px-8 xl:py-7">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
